import { ajax } from '../index'

/**
 * buying guides 相关接口
 */
export default {
  // 获取buying-guides数据
  getBuyingGuides(dataObj?: any) {
    return ajax.get('api', `/api/v1/buying-guides`, dataObj)
  },

  // 获取buying-guides 详情数据
  getBuyingGuidesDetail(dataObj?: any) {
    return ajax.get('api', `/api/v1/buying-guides/guide-detail`, dataObj)
  }
}